import React from 'react';
import { Modal } from 'react-bootstrap';
import ButtonMain from '../../../../Atoms/ButtonMain';
import ButtonSecondary from '../../../../Atoms/ButtonSecondary';
import IdeaReviewCard from '../IdeaReviewCard';
import useBrainstormStore from '../../../../../hooks/useBrainstormStore';
import './styles.css';

export default function KnowledgeBaseModal({ 
    show, 
    onHide, 
    brainstormId,
    onToggleKnowledgeBase,
    handleConclude,
    loading
}) {
    const { getBrainstormById, getGuidingQuestionsByChallenge } = useBrainstormStore();

    const handleCancel = () => {
        onHide();
    };

    const brainstorm = getBrainstormById(brainstormId);
    const selectedChallenge = brainstorm?.challenges.find(challenge => challenge.selected === true);
    const guidingQuestions = selectedChallenge ? 
        getGuidingQuestionsByChallenge(brainstormId, selectedChallenge.id).filter(question => question.selected === true) : 
        [];

    return (
        <Modal 
            show={show} 
            onHide={handleCancel}
            centered
            backdrop="static"
            className="knowledge-base-modal"
            size="lg"
        >
            <Modal.Header closeButton className="knowledge-base-modal-header">
                <Modal.Title>Itens selecionados para a Base de conhecimento</Modal.Title>
            </Modal.Header>
            
            <Modal.Body className="knowledge-base-modal-body">
                <div className="guiding-questions-list">
                    {guidingQuestions.map((question) => {
                        const ideas = question.ideas || [];
                        const selectedIdeasCount = ideas.filter(idea => idea.selected === true).length;
                        
                        return (
                            <IdeaReviewCard
                                key={question.id}
                                guidingQuestion={question}
                                selectedIdeasCount={selectedIdeasCount}
                                isInKnowledgeBase={question.in_knowledge_base || false}
                                onToggle={() => onToggleKnowledgeBase(brainstormId, question.id)}
                            />
                        );
                    })}
                </div>
            </Modal.Body>
            
            <Modal.Footer className="knowledge-base-modal-footer">
                <ButtonSecondary onClick={handleCancel} disabled={loading}>
                    Cancelar
                </ButtonSecondary>
                
                <ButtonMain onClick={handleConclude} disabled={loading}>
                    {loading ? 'Concluindo...' : 'Concluir'}
                </ButtonMain>
            </Modal.Footer>
        </Modal>
    );
}
